<p
  class="document-edit-lock-toast__message"
  [innerHTML]="messageKey | translate: { ownerName: escapedOwnerName }"
></p>
<button type="button" class="document-edit-lock-toast__close" (click)="dismiss()">
  {{ 'close' | translate }}
</button>
